/**
 * Minimal rich-text renderer for admin-editable copy.
 * Supports ONLY **bold** and [label](url), plus newlines as <br/>.
 * Everything else is rendered literally, so plain text is unchanged.
 */

function parseInline(line, emphasisClass) {
  const nodes = [];
  let remaining = line;
  let key = 0;
  const re = /(\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)]+)\))/;
  let m;
  while ((m = re.exec(remaining))) {
    const before = remaining.slice(0, m.index);
    if (before) nodes.push(before);
    if (m[2] !== undefined) {
      nodes.push(<strong key={key++} className={emphasisClass}>{m[2]}</strong>);
    } else {
      const external = /^https?:\/\//.test(m[4]);
      nodes.push(
        <a
          key={key++}
          href={m[4]}
          className="underline text-primary hover:opacity-90"
          {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
        >
          {m[3]}
        </a>,
      );
    }
    remaining = remaining.slice(m.index + m[0].length);
  }
  if (remaining) nodes.push(remaining);
  return nodes;
}

export function renderRich(text, emphasisClass = "text-primary") {
  if (text == null) return null;
  const lines = String(text).split("\n");
  return lines.map((line, li) => (
    <span key={li}>
      {li > 0 && <br />}
      {parseInline(line, emphasisClass)}
    </span>
  ));
}
